import { defineMessages } from 'react-intl'

export const journalMessages = defineMessages({
  loading: {
    id: 'journalMessages.loading',
    defaultMessage: 'Loading the Journal',
    description: 'A loading message for the Journal feature'
  }
})

export const newsMessages = defineMessages({
  loading: {
    id: 'newsMessages.loading',
    defaultMessage: 'Loading News',
    description: 'A loading message for the News feature'
  },
  keepInTouch: {
    id: 'newsMessages.keepInTouch',
    defaultMessage: 'Keep in touch'
  },
  contactUs: {
    id: 'newsMessages.contactUs',
    defaultMessage: 'Contact Us',
    description: 'Get in touch'
  },
  mediaKit: {
    id: 'newsMessages.mediaKit',
    defaultMessage: 'Download Media Kit'
  }
})

export const sharedMessages = defineMessages({
  loadingArticle: {
    id: 'sharedMessages.loadingArticle',
    defaultMessage: 'Loading your Article',
    description: 'A loading message for an article'
  }
})
